<template>
    <div class="AccountSearch">
        <Row :gutter="4">
            <!-- 选择公司 -->
            <div v-if="company==1">
              <Col span="4">
                <Select v-model="companyId" filterable :placeholder="$t('permission_configuration_management.account.pleaseSelectCompany')" :transfer="true" @on-change="searchCompany">
                  <Option value=" " selected>{{$t('permission_configuration_management.account.all')}}</Option>
                  <Option :value="item.id" v-for="item in companyList" :key="item.id">{{item.name}}</Option>
                </Select>
              </Col>
            </div>
            <Col span="3">
                <!-- 账户类型下拉 -->
                <Select v-model="accountType" clearable :placeholder="$t('permission_configuration_management.account.accountType')" :transfer="true">
                  <Option :value="item.id" v-for="item in accountTypeList" :key="item.id">{{item.name}}</Option>
                </Select>
            </Col>
            <Col span="3">
                <!-- 账户ID -->
                <Input v-model="accountId" :placeholder="$t('permission_configuration_management.account.accountId')" />
            </Col>
            <Col span="3">
                <!-- 账户名称 -->
                <Input v-model="accountSearchKey" :placeholder="$t('permission_configuration_management.account.checkByAccountName')" />
            </Col>
            <Col span="11">
                <div style="display: flex; align-items: center; flex-wrap: nowrap;">
                    <Button type="primary" @click="search" style="margin-right: 3px;">{{$t('message.select')}}</Button>
                    <Button type="primary" @click="addOrUpdateHandle" style="margin-right: 3px;" v-hasPermission="['permissionsConfigurationManagement:accounts:add_account']">{{$t('permission_configuration_management.account.addAccount') }}</Button>
                    <add-or-update-accounts v-if="addOrUpdateVisible" ref="addOrUpdate"></add-or-update-accounts>
                    <resource-scan></resource-scan>
                </div>
            </Col>
        </Row>
    </div>
</template>
<script>
    import {setCookie,getCookie} from '../../../../utils/cookieUtil.js'
    import AddOrUpdateAccounts from './AddOrUpdateAccounts'
    import TableAccounts from '../account/TableAccounts'
    import ResourceScan from '../account/ResourceScan'
    var tableAccounts = TableAccounts;
    export default {
        name: 'AccountSearch',
        components: {
            AddOrUpdateAccounts,
            ResourceScan
        },
        data () {
            return {
                addOrUpdateVisible:false,
                company: getCookie(global.companyId),
                companyId: '',
                companyList: [],
                accountSearchKey:'',
                accountType: '',
                accountId: '',
                accountTypeList: []
            }
        },
        mounted: function(){
            if (this.company == 1) {
                this.getCompanyDropDownBox();
            }
            this.getAccountTypeList();
        },
        methods: {
            // 获取公司下拉框
            getCompanyDropDownBox: function(){
                this.$api.company.getCompanyDropDownBox("userName",getCookie(global.cookieName))
                .then(res => {
                    this.companyList = res.data;
                });
             },
            // 获取账户类型列表
            getAccountTypeList: function(){
                this.$api.account.queryCloudList()
                .then(res => {
                    this.accountTypeList = res.data;
                });
            },
            // 按公司搜索
            searchCompany: function(){
                eventBus.$emit('companyId', this.companyId);
                tableAccounts.methods.showAll();
            },
            // 查询
            search: function(){
                eventBus.$emit('accountSearchName', this.accountSearchKey);
                eventBus.$emit('companyId', this.companyId);
                eventBus.$emit('accountType', this.accountType);
                eventBus.$emit('accountId', this.accountId);
                tableAccounts.methods.showAll();
            },
            // 添加
            /**********************************************************/
            addOrUpdateHandle:function(){
                this.addOrUpdateVisible=true;
                this.$nextTick(() => {
                    this.$refs.addOrUpdate.init()
                })
            }
        }
    }
</script>
<style scoped>
    .AccountSearch
    {
        padding: 4px 0px 15px 0px;
    }
</style>



// WEBPACK FOOTER //
// src/components/configuration/permissions_configuration_management/account/AccountSearch.vue